import { useState } from 'react';
import DriverSpecialNeedsCard from './DriverSpecialNeedsCard';
import Lawenforcementinstructionscard from './Lawenforcementinstructionscard';

export default function BlueEnvelopeTemplate() {
  const [instructionsOpen, setInstructionsOpen] = useState(false);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="blue-envelope-template-root font-sans bg-white min-h-screen print:min-h-0 print:h-0">
      {/* Top bar – Instructions & Print */}
      <div className="absolute top-5 right-5  flex flex-col gap-3 z-5 print:hidden">
        <button
          type="button"
          onClick={() => setInstructionsOpen(true)}
          className="px-6 py-3 bg-purple-900 text-white border-none rounded-md text-base cursor-pointer shadow-lg hover:bg-purple-800 transition-colors"
        >
          📝 Instructions
        </button>
        <button
          type="button"
          onClick={handlePrint}
          className="px-6 py-3 bg-purple-900 text-white border-none rounded-md text-base cursor-pointer shadow-lg hover:bg-purple-800 transition-colors"
        >
          🖨️ Print Envelope
        </button>
      </div>

      {/* Instructions dialog */}
      {instructionsOpen && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100] p-4 print:hidden"
          onClick={() => setInstructionsOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-labelledby="instructions-title"
        >
          <div
            className="bg-white border-2 border-gray-200 rounded-lg p-6 max-w-4xl  w-full shadow-xl relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => setInstructionsOpen(false)}
              className="absolute top-0 right-0 p-2 bg-gray-200 text-gray-900 font-semibold rounded-full hover:bg-gray-300 transition-colors"
            >
               <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
            <iframe
              src={"/blueEnvelopeInstructions.html"}
              className="w-full h-[700px] mt-4"
              style={{ borderRadius: "5px" }}
              title="Instructions"
              onLoad={() => { }}
            />
            
          </div>


        </div>
      )}

      {/* Centered template */}
      <div className="blue-envelope-print-wrapper flex items-start justify-start min-h-screen pt-0 pb-0 print:py-0 print:min-h-0 print:h-0 print:overflow-hidden">
        {/* Page – sky-100 except cut-out corners (print-only area) */}
        <div
          className="blue-envelope-print-area relative bg-sky-100 print:shadow-none"
          style={{
            width: '11in',
            height: '8.5in',
          }}
        >
          <span className="absolute text-md text-blue-600 font-bold" style={{ left: '50%', top: '3%' }}>4</span>

          {/* Horizontal crease line at 5" from top */}
          <div
            className="absolute left-0 border-t-2 border-dashed border-blue-300 w-[3.7in] md:w-[10in]"
            style={{ top: '5in', height: 0 }}
          />

          {/* Top fold line at 1" from top */}
          <div
            className="absolute border-t-2 border-dashed border-blue-300 w-[2.7in] md:w-[10in] "
            style={{ left: '0.5in', top: '1in', height: 0 }}
          />
            

          {/* Vertical margin guides */}
          <div
            className="absolute top-0 border-l border-gray-300"
            style={{ left: '0.5in', height: '8.5in', width: 0 }}
          />
            
          <div
            className="absolute top-0 border-r border-gray-300"
            style={{ right: '0.5in', height: '8.5in', width: 0 }}
          />

          {/* Side fold lines */}
          <div
            className="absolute left-0 border-2 border-dashed border-blue-300"
            style={{
              top: '1in',
              width: '0.5in',
              height: '4in',
              backgroundColor: 'rgba(100, 181, 246, 0.05)',
            }}
          >
            <span className="absolute text-md text-blue-500 font-bold" style={{ left: '30%', bottom: '50%', writingMode: 'vertical-rl', transform: 'rotate(270deg)' }}>1</span>
          </div>
          <div
            className="absolute right-0 border-2 border-dashed border-blue-300"
            style={{
              top: '1in',
              width: '0.5in',
              height: '4in',
              backgroundColor: 'rgba(100, 181, 246, 0.05)',
            }}
          >
            <span className="absolute text-md text-blue-500 font-bold" style={{ right: '30%', bottom: '50%', writingMode: 'vertical-rl', transform: 'rotate(270deg)' }}>2</span>
          </div>

          {/* Cut marks - bottom left corner (cut out – no sky-100) */}
          <div
            className="absolute left-0 border-2 border-dashed border-red-500 bg-white"
            style={{
              top: '5in',
              width: '0.5in',
              height: '3.5in',
            }}
          />

          {/* Cut marks - bottom right corner (cut out – no sky-100) */}
          <div
            className="absolute right-0 border-2 border-dashed border-red-500 bg-white"
            style={{
              top: '5in',
              width: '0.5in',
              height: '3.5in',
            }}
          />

          {/* Cut marks - top left corner (cut out – no sky-100) */}
          <div
            className="absolute left-0 top-0 border-2 border-dashed border-red-500 bg-white"
            style={{
              width: '0.5in',
              height: '1in',
            }}
          />

          {/* Cut marks - top right corner (cut out – no sky-100) */}
          <div
            className="absolute right-0 top-0 border-2 border-dashed border-red-500 bg-white"
            style={{
              width: '0.5in',
              height: '1in',
            }}
          />

          {/* Scissors icons - bottom */}
          <span
            className="absolute text-base text-red-500 font-bold"
            style={{ left: '0.15in', top: '4.85in' }}
          >
            ✂️
          </span>
          <span
            className="absolute text-base text-red-500 font-bold"
            style={{ right: '0.15in', top: '4.85in' }}
          >
            ✂️
          </span>

          {/* CUT OFF labels - bottom */}
          <span
            className="absolute text-xs text-red-500 font-bold"
            style={{
              left: '0.05in',
              top: '6.5in',
              writingMode: 'vertical-rl',
              transform: 'rotate(180deg)',
            }}
          >
            CUT OFF
          </span>
          <span
            className="absolute text-xs text-red-500 font-bold"
            style={{
              right: '0.05in',
              top: '6.5in',
              writingMode: 'vertical-rl',
              transform: 'rotate(180deg)',
            }}
          >
            CUT OFF
          </span>

          {/* Scissors icons - top */}
          <span
            className="absolute text-base text-red-500 font-bold"
            style={{ left: '0.15in', top: '0.05in' }}
          >
            ✂️
          </span>
          <span
            className="absolute text-base text-red-500 font-bold"
            style={{ right: '0.15in', top: '0.05in' }}
          >
            ✂️
          </span>

          {/* CUT labels - top */}
          <span
            className="absolute text-xs text-red-500 font-bold"
            style={{
              left: '0.05in',
              top: '0.3in',
              writingMode: 'vertical-rl',
              transform: 'rotate(180deg)',
            }}
          >
            CUT
          </span>
          <span
            className="absolute text-xs text-red-500 font-bold"
            style={{
              right: '0.05in',
              top: '0.3in',
              writingMode: 'vertical-rl',
              transform: 'rotate(180deg)',
            }}
          >
            CUT
          </span>

          {/* Instruction labels */}
          <span
            className="absolute text-blue-500"
            style={{ left: '0.6in', top: '0.05in', fontSize: '9px' }}
          >
            ⬅ 0.5" margin
          </span>
          <span
            className="absolute text-blue-500"
            style={{ right: '0.6in', top: '0.05in', fontSize: '9px' }}
          >
            0.5" margin ➡ 
          </span>
          <span
            className="absolute text-blue-600"
            style={{ left: '0.6in', top: '0.9in', fontSize: '9px' }}
          >
            ← Top fold line (1" from top) {'- '.repeat(80)}→
          </span>
          <span
            className="absolute text-blue-600"
            style={{ left: '0.6in', top: '4.9in', fontSize: '9px' }}
          >
            ← Bottom fold line (3.5" from bottom) {'- '.repeat(75)}→ 
          </span>

          {/* Middle section – Driver instructions card (centered) */}
          <div
            className="blue-envelope-middle-section absolute flex items-center justify-center overflow-hidden w-[2.71in] md:w-[10in]"
            style={{
              left: '0.5in',
              top: '1in',
              height: '4in',
            }}
          >
            <div className="blue-envelope-middle-inner w-full h-full flex items-center justify-center origin-center">
              <DriverSpecialNeedsCard embedded />
            </div>
          </div>

          {/* Bottom part – Law Enforcement card (rotated 180°) */}
          <div
            className="blue-envelope-bottom-section absolute overflow-hidden"
            style={{
              left: '0.5in',
              top: '5.25in',
              width: '10in',
              height: '3in',
            }}
          >
            <div
              className="blue-envelope-bottom-inner w-[2.7in] md:w-full h-full flex items-center justify-center"
              style={{ transform: 'rotate(180deg)' }}
            >
              <span className="absolute text-md text-blue-500 font-bold" style={{ right: '50%', bottom: '0.01in', writingMode: 'vertical-rl', transform: 'rotate(270deg)' }}>3</span>
              <Lawenforcementinstructionscard embedded />
            </div>
          </div>
        </div>
      </div>

      {/* Print: one page, no header, envelope visible */}
      <style>{`
        @page {
          size: 11in 8.5in;
          margin: 0;
        }
        @media print {
          html, body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            margin: 0;
            padding: 0;
            height: 8.5in !important;
            max-height: 8.5in !important;
            overflow: hidden !important;
          }
          header {
            display: none !important;
          }
          body * {
            visibility: hidden;
          }
          .blue-envelope-template-root,
          .blue-envelope-template-root .blue-envelope-print-wrapper,
          .blue-envelope-template-root .blue-envelope-print-area,
          .blue-envelope-template-root .blue-envelope-print-area * {
            visibility: visible;
          }
          .blue-envelope-print-area {
            position: fixed;
            left: 0;
            top: 0;
          }
        }
      `}</style>
    </div>
  );
}
